import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'

//定义加载中的图片(如果用到的话可以用)
// const loadimage = require('~/static/icons/common/loading.gif')
//定义加载图片出错的时候展现的图片
const errorimage = 'https://oss.pzds.com/alimini/202402231406215.webp'

Vue.use(VueLazyLoad, {
	preLoad: 1.33, //预加载高度比例
	loading: errorimage,
	error: errorimage, //加载失败时图像的src
	attempt: 2, //尝试计数次数
	throttleWait: 500 //节流等待时间(通过调节此值可以查看loading的效果，根据实际情况调节)
})
